import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta20 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-20/utils-consultaSeguimentoPergunta20'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { isUndefinedOrNull } from 'util/checks'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleVerticalTableItem } from '../components/HistoricoMChatSimpleVerticalTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { getOutroOuPergunta, getOutroOuResposta } from '../utils-HistoricoMchatRf'
import { convertAplicacaoPergunta20 } from './converter-HistoricoMchatPergunta20'

interface HistoricoMChatRfPergunta20Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta20 = (props: Readonly<HistoricoMChatRfPergunta20Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta20(aplicacoes)
  if (converted === null) return null

  const { header, subItemComplementar, perguntas, model } = converted
  if (isUndefinedOrNull(header)) return null

  const resultado = calculateResultadoPergunta20(model)
  const hasPerguntas = perguntas.length > 0

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='20'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={undefined}
      />
      {subItemComplementar && (
        <HistoricoMChatSimpleVerticalTableItem
          pergunta={`"${getOutroOuPergunta(subItemComplementar)}"`}
          resposta={getOutroOuResposta(subItemComplementar)}
        />
      )}
      {hasPerguntas && <HistoricoMChatSimpleVerticalTableItem pergunta='“O seu filho...”' resposta={undefined} />}
      {hasPerguntas && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={perguntas} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
